import { createContext, useContext } from 'react'

type ParagonContextType = string | undefined

const ParagonContext = createContext<ParagonContextType>(undefined)

export const useParagon = () => useContext(ParagonContext)

export default ParagonContext
